import { createSlice } from "@reduxjs/toolkit";

const initialValue = {
    _id : "",
    name : "",
    email : "",
    avatar : "",
    mobile : "",
    verifyEmail : "",
    lastLogin_Date : "",
    status : "",
    role : "",
    university:""
}

const userSlice  = createSlice({
    name : 'user',
    initialState : initialValue,
    initialState : initialValue,
    reducers : {
        setUserDetails : (state,action) =>{
            state._id = action.payload?._id
            state.name = action.payload?.name
            state.email = action.payload?.email
            state.avatar = action.payload?.avatar
            state.mobile = action.payload?.mobile
            state.verifyEmail = action.payload?.verify_email
            state.lastLogin_Date = action.payload?.last_login_date
            state.status = action.payload?.status
            state.role = action.payload?.role
            state.university = action.payload?.university || null;
        }
    }
})
export const { setUserDetails} = userSlice.actions
export default userSlice.reducer